import * as React from 'react';
import {useRoute} from 'react-router5';
import {getUserByID} from 'api/user/requests';
import {UserObject} from 'stores/UserStore';
import isError from 'helpers/isError';
import validateResponse from 'helpers/validate-response';
import {ProfileView} from 'components/Profile';
import {Helmet} from 'react-helmet';

/**
 * The view student page.
 * @return {React.ReactElement}
 * @constructor
 */
export default function ViewStudent(): React.ReactElement {
  const {route} = useRoute();

  const [
    student, setStudent,
  ] = React.useState<UserObject | undefined>(undefined);

  React.useEffect(() => {
    getUserByID(route.params.studentId).then((response) => {
      validateResponse(response);

      if (response && !isError(response)) {
        setStudent(response);
      }
    })
  }, [route.params.studentId]);

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Просмотр студента</title>
      </Helmet>
      {student && (
        <ProfileView
          name={student.name}
          nickname={student.username}
          avatar={student.avatar || undefined}
          contacts={{
            phone: student.contacts?.phone,
            email: student.email,
          }}
          socials={{
            telegram: student.contacts?.telegram,
            instagram: student.contacts?.instagram,
          }}
        />
      )}
    </React.Fragment>
  );
}
